import { jsx } from "react/jsx-runtime";
import { useTldrawUiComponents } from "../../context/components.mjs";
function DefaultSharePanel() {
  const { PeopleMenu } = useTldrawUiComponents();
  if (!PeopleMenu) return null;
  return /* @__PURE__ */ jsx("div", { className: "tlui-share-zone", draggable: false, children: /* @__PURE__ */ jsx(PeopleMenu, {}) });
}
export {
  DefaultSharePanel
};
//# sourceMappingURL=DefaultSharePanel.mjs.map
